import React from "react";
import Slideshow from "./slideshow/slideshow";
import ClubBar from "./ClubBar/ClubBar";


const Home = () => {
  return (
    <div>
      <Slideshow />
      
      <ClubBar />
    </div>
  );
};
export default Home;
